/**
 * @fileOverview Contains context utilities mainly for exposing environment
 * variables to other components.
 * @name context.js
 */
import React from "react";

export const brand = import.meta.env.VITE_APP_BRANDNAME || "";
export const withAuth = import.meta.env.VITE_APP_PRIVATE_WEBSITE === "true";
export const noAuthAccess = import.meta.env.VITE_APP_NOAUTH_ACCESS === "true";
export const authProvider = import.meta.env.VITE_APP_AUTH_PROVIDER;
export const authVendor = import.meta.env.VITE_APP_AUTH_VENDOR;
export const externalLoginUrl = import.meta.env.VITE_APP_AUTH_LOGIN_URL;
export const externalProfileUrl = import.meta.env.VITE_APP_EXT_PROFILE_URL;
export const redirectUrl = import.meta.env.VITE_APP_AUTH_SUCCESS_REDIRECT;
export const withTripadvisor = import.meta.env.VITE_APP_TRIPADVISOR === "true";
export const custom_auth = import.meta.env.VITE_APP_EXT_CUSTOM_AUTH === "true";
export const ext_crm = import.meta.env.VITE_APP_EXT_CRM === "true";
export const source_entity = import.meta.env.VITE_APP_SOURCE_ENTITY;

export const AuthEnvContext = React.createContext({
  auth0: null,
  withAuth,
  noAuthAccess,
  authProvider,
  redirectUrl,
  authVendor,
  externalLoginUrl,
  custom_auth,
});

/**
 * A simple HOC designed to pass environment context data to components
 * which cannot import the AuthEnvContext.
 * @param {React.Component} WrappedComponent
 * @returns {React.Component}
 */
export const AuthEnvContextHoc = (WrappedComponent: React.ComponentType) => {
  const Comp = (props: any) => {
    return (
      <AuthEnvContext.Consumer>
        {(contexts) => <WrappedComponent {...props} {...contexts} />}
      </AuthEnvContext.Consumer>
    );
  };
  return Comp;
};

export const NoScrollContext = React.createContext({
  toggleNoScroll: () => {
    return;
  },
});

export const GlobalModalsContext = React.createContext({});
